import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@ann/web-components';
import ModalBase from '../ModalBase';
import { ModalContent, ActionsContainer } from '../Modal.styled';
import AssignModalContent from './AssignModalContent';
import PendingAgentsList from './PendingAgentsList';
import CurrentAgentsList from './CurrentAgentsList';
import ConfirmAssignModal from './ConfirmAssignModal';


const AssignAgentModal = observer(({
    isOpen,
    store,
    onClose,
    onConfirm,
}) => {
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    const handleAddToAgentsClick = () => {
        setIsConfirmModalOpen(true);
    };

    const handleConfirmAssign = () => {
        setIsConfirmModalOpen(false);
        onConfirm();
    };

    const handleCloseConfirmModal = () => {
        setIsConfirmModalOpen(false);
    };

    const documentCount = store.itemsToAssignAgent.length;
    const agentCount = store.pendingAgents.length;

    const getTitle = () => {
        if (documentCount === 1) {
            return "Add this document to agents";
        } else {
            return `Add these documents to agents`;
        }
    };

    const getDescription = () => {
        if (documentCount === 1) {
            return `Assign agents to "${store.itemsToAssignAgent[0]?.name}"`;
        } else {
            return `Assign agents to ${documentCount} documents`;
        }
    };

    return (
        <>
            <ModalBase
                isOpen={isOpen}
                onClose={onClose}
                title={getTitle()}
            > 
                <ModalContent>
                    
                    <AssignModalContent
                        itemsToAssign={store.itemsToAssignAgent}
                        selectedAgents={store.selectedAgents}
                        onAgentsChange={store.setSelectedAgents}
                        onGiveAccess={store.addToPendingAgents}
                        suggestions={store.agentsStore.agents}
                    />

                    <PendingAgentsList
                        pendingAgents={store.pendingAgents}
                        onRemove={store.removePendingAgent}
                    />

                    <CurrentAgentsList
                        shouldShow={true}
                        agents={store.currentAgents}
                        isLoading={store.isLoadingAgents}
                        onRemove={store.removeAgent}
                    />
                </ModalContent>

                <ActionsContainer>
                    {store.pendingAgents.length > 0 && (
                        <Button
                            label="Add to agents"
                            size="medium"
                            type="primary"
                            onClick={handleAddToAgentsClick}
                            disabled={store.isLoadingAssign}
                        />
                    )}
                </ActionsContainer>
            </ModalBase>

            <ConfirmAssignModal
                itemsToAssign={store.itemsToAssignAgent}
                pendingAgents={store.pendingAgents}
                isOpen={isConfirmModalOpen}
                onClose={handleCloseConfirmModal}
                onConfirm={handleConfirmAssign}
                documentCount={documentCount}
                agentCount={agentCount}
                isLoading={store.isLoadingAssign}
            />
        </>
    );
});

export default AssignAgentModal;